import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * useBranches — small shared hook that fetches the current user's visible
 * branches from GET /branches. Admins see all; other roles see only branches
 * present in their `allowed_branch_ids`.
 */
export function useBranches() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get("/branches");
      setBranches(data || []);
    } catch (e) {
      setError(e);
      setBranches([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { branches, loading, error, reload };
}

export function branchColor(idx) {
  // Deterministic palette so Office / Factory / future branches get consistent chips.
  const palette = [
    { bg: "bg-[#fcf0f3]", fg: "text-[#7C1D3A]", border: "border-[#f5c4d3]" },
    { bg: "bg-emerald-50", fg: "text-emerald-800", border: "border-emerald-200" },
    { bg: "bg-sky-50", fg: "text-sky-800", border: "border-sky-200" },
    { bg: "bg-amber-50", fg: "text-amber-800", border: "border-amber-200" },
    { bg: "bg-violet-50", fg: "text-violet-800", border: "border-violet-200" },
  ];
  return palette[idx % palette.length];
}
